import { useEffect, useState } from "react";

import useService from "../../../../../../../../hooks/useService";

const useDocumentUploadState = ({
  data,
  handleAnswerChange,
  hasDisposition,
  preAuthUrl,
  questionKey,
  schema,
}) => {
  const enumRepository = useService("repositories/enum-repository");
  const preSignedUrlRepository = useService("repositories/pre-signed-url-repository");

  const [openModal, setOpenModal] = useState(false);
  const [selectedDocument, setSelectedDocument] = useState(null);
  const [selectedDisposition, setSelectedDisposition] = useState(null);
  const [dispositionOpts, setDispositionOpts] = useState([]);
  const preAuthUrlFormatted = preAuthUrl?.replace("/api/", "");

  async function fetchOptions(url) {
    const options = await enumRepository.query({
      urlPath: url.replace("/api/", ""),
    });
    const mappedOpts = options.map((opt) => ({ key: opt.key, value: opt.value }));
    setDispositionOpts(mappedOpts);
  }

  async function handleSubmit(body) {
    let newFile = selectedDocument.file;

    if (body?.file) {
      // First, get the pre-signed URL using the file name
      const { url } = await preSignedUrlRepository.upload(
        { file_name: body.file.name },
        {
          urlPath: preAuthUrlFormatted,
        },
        "POST"
      );
      // Then, upload the file using the pre-signed URL
      await preSignedUrlRepository.upload(
        body.file,
        {
          urlPath: url,
          isExternalPath: true,
        },
        "PUT"
      );
      newFile = url;
    }

    const newSelectedDocument = { ...selectedDocument, ...body, file: newFile };
    setSelectedDocument(newSelectedDocument);

    if (hasDisposition) {
      handleAnswerChange(questionKey, {
        disposition: {
          option: selectedDisposition,
        },
        document: newSelectedDocument,
      });
      return;
    }

    handleAnswerChange(questionKey, newSelectedDocument);
  }

  function handleDispositionChange(value) {
    setSelectedDisposition(value);
    handleAnswerChange(questionKey, {
      disposition: {
        option: value,
      },
      document: selectedDocument,
    });
  }

  useEffect(() => {
    if (hasDisposition) {
      setSelectedDisposition(data?.disposition?.option || null);
      setSelectedDocument(data?.document || null);
      return;
    }
    setSelectedDocument(data || null);
  }, [data]);

  useEffect(() => {
    if (hasDisposition && schema) {
      const expectedInput = schema[schema.expected_input];
      const expectedOutputRef = expectedInput?.properties?.disposition?.$ref;
      const url = schema[expectedOutputRef]?.properties?.option?.enum || "";
      fetchOptions(url);
    }
  }, [schema]);

  return {
    handleDispositionChange,
    handleSubmit,
    openModal,
    setOpenModal,
    selectedDisposition,
    selectedDocument,
    dispositionOpts,
  };
};

export default useDocumentUploadState;
